import React, {Component} from "react";
import {Runtime, Inspector} from "@observablehq/runtime";
import notebook from "@namitmohale/stacked-bar-chart";
import ReactToPdf from 'react-to-pdf';

class StackChart extends Component {
    constructor(props){
        super(props);
        this.state = {
            data: props.data,
            SCREEN_WIDTH: window.innerWidth
        }
        console.log(props.data)
    }
    animationRef = React.createRef();
    pdfRef = React.createRef();
  
    componentDidMount() {
      const runtime = new Runtime().module(notebook, name => {
        if (name === "chart") {
          return new Inspector(this.animationRef.current);
        }
      });
      
      runtime.redefine("text", (this.state.data));
      
      runtime.redefine("height", 330);
      // runtime.redefine("width", this.state.SCREEN_WIDTH*91/128);
      // runtime.redefine("width", 850);
      runtime.redefine("margin", ({top: 40, left: 30, right: 100, bottom: 50}))
      runtime.redefine("titleSize", 15)
      runtime.redefine("xTextSize", 12)
      runtime.redefine("dotRadius", 6)
      runtime.redefine("labelSize", 12)
      runtime.redefine("yTextSize", 12)
      runtime.redefine("titleText", this.props.title)
      
    }

    componentDidUpdate(prevProps, prevState) {
      if(prevProps.data !== this.props.data || prevState.SCREEN_WIDTH !== window.innerWidth){
          console.log(this.props.data);
          this.setState({SCREEN_WIDTH: window.innerWidth})
          const runtime = new Runtime().module(notebook, name => {
            if (name === "chart") {
              return new Inspector(this.animationRef.current);
            }
          });
          
          runtime.redefine("text", (this.props.data));
          
          runtime.redefine("height", 350);
          // runtime.redefine("width", 850);
          // runtime.redefine("width", this.state.SCREEN_WIDTH*91/128);
          
          runtime.redefine("margin", ({top: 40, left: 30, right: 100, bottom: 50}))
          runtime.redefine("titleSize", 15)
          runtime.redefine("xTextSize", 12)
          runtime.redefine("dotRadius", 6)
          runtime.redefine("labelSize", 12)
          runtime.redefine("yTextSize", 12)
          runtime.redefine("titleText", this.props.title)

      }
  }
  
    render() {
      return (
        <div style={{padding: 20}}>
          {/* <div ref={this.animationRef}></div> */}
          <div className="ui grid" ref={this.pdfRef} style={{display:'flex', flex:1}}>
                    {/* <div className="thirteen wide column" style={{}} ref={this.animationRef}></div> */}
                    <div className="twelve wide column" style={{display:'flex', flex:3/5, width: this.state.SCREEN_WIDTH*91/128,}}>
                        <div className="twelve wide column" style={{ width: this.state.SCREEN_WIDTH*91/128,}} ref={this.animationRef}></div>
                    </div>
                    <div className="four wide column" style={{ display:'flex', flex:1, flexDirection: 'column', justifyContent:'flex-start', paddingLeft: 5 }}>
                        <p>Note: Hover over the graph to see more details</p>
                        <p></p>
                        {this.props.description.map((line, index) => {
                            return <p key={index} style={{ }}>{line}</p>
                        })}
                    </div>
                </div>
                <div className="row" style={{display:'flex', flex:1}}>
          <ReactToPdf x={0} y={0} 
                          targetRef={this.pdfRef} 
                          filename="div-blue.pdf" 
                          height='800' 
                          options={{
                              "orientation":'landscape', 
                              "format":'a4', 
                              margins : {
                                  top: 0,
                                  bottom: 0,
                                  left: 0,
                                  // height: 1000,
                                  // width: '100%'
                              }
                          }}
              >
          {({toPdf}) => (
            <button onClick={toPdf}>Generate pdf</button>
          )}
        </ReactToPdf>
        </div>

        </div>
        // <div style={{padding: 20}}>
        //         <div className="ui grid" style={{display:'flex', flex:1}} ref={this.pdfRef}>
        //             {/* <div className="ui row" style={{display:'flex', flex:3/4}} ref={this.animationRef}></div> */}
        //             <div className="ui column" style={{ display:'flex', flex:1/4, flexDirection: 'column', justifyContent:'flex-start', paddingLeft: 5 }}>
        //                 <p>Note: Hover over the graph to see more details</p>
        //                 <p></p>
        //                 {this.props.description.map((line, index) => {
        //                     return <p key={index} style={{ }}>{line}</p>
        //                 })}
        //             </div>
        //             <div ref={this.animationRef}></div>
        //         </div>
        //         <ReactToPdf x={0} y={0} 
        //                     targetRef={this.pdfRef} 
        //                     filename="div-blue.pdf" 
        //                     height='800' 
        //                     options={{
        //                         "orientation":'landscape', 
        //                         "format":'a4', 
        //                         margins : {
        //                             top: 0,
        //                             bottom: 0,
        //                             left: 0,
        //                             // height: 1000,
        //                             // width: '100%'
        //                         }
        //                     }}
        //         >
				// 	{({toPdf}) => (
				// 		<button onClick={toPdf}>Generate pdf</button>
				// 	)}
				// </ReactToPdf>
        //     </div>
      );
    }
  }
  
  export default StackChart;